import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';



interface NoteProps {
  children: ReactNode;
}
const Note: React.FC<NoteProps> = ({ children }) => {
    return (
        <div className="info note">
            <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
            <span>{children}</span>
        </div>
    );
};

export default Note;
